import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import ja from './ja'

Vue.use(VueI18n)

const savedLocale = localStorage.getItem('unsub-locale')

const i18n = new VueI18n({
    locale: savedLocale || 'en',
    fallbackLocale: 'en',
    messages: { en, ja },
    silentTranslationWarn: true,
})

export default i18n
